// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XWM3","rootNoMargin":"styles_rootNoMargin__1KkiN"};